<template>
  <footer class="main-footer">
    <section class="logo container">
      <div class="logo__container">
        <div class="logo__image">
          <img src="../assets/sequire-light.svg" alt="Sequire Logo">
        </div>
        <p>SMS Campaigns</p>
      </div>
      <div class="logo__text">
        <div class="logo__element">
          <i class="fa-solid fa-user"></i>
          <p>Reach out our Sales Team</p>
        </div>
        <div class="logo__element">
          <i class="fa-solid fa-envelope"></i>
          <p><a href="mailto:erik.carlson@srax.com">Sales@SRAX.com</a></p>
        </div>
      </div>
    </section>
    <hr>
  </footer>
</template>

<style lang="scss" scoped>
  @import '@/styles/components/footer.scss';
</style>

<script>
export default {
  name: 'Footer',
  data() {
    return {
    };
  },
};
</script>